import { SpeakerNotes } from "@styled-icons/material";

export const pronunciationConstants = {
  icon: SpeakerNotes,
};
